import { EMAIL_VALIDATION_REGEX, PHONE_VALIDATION_REGEX } from './regex'

export const FORM_DEFAULT_REQUIRED = {
  value: true,
  message: 'Required'
}

// export const FORM_DEFAULT_REQUIRED = {
//   value: true,
//   message: 'Required'
// }

export const formEmailPatternInvalid = {
  value: EMAIL_VALIDATION_REGEX,
  message: 'Invalid email address'
}

export const formPhonePatternInvalid = {
  value: PHONE_VALIDATION_REGEX,
  message: 'Invalid phone number'
}
